import React from 'react';
import {useSelector} from "react-redux";
import ProductListUi from "./ProductListUi";
import {PRODUCT_LIST_TYPE} from "../../../../constants/commons";
import {safeImage} from "../../../../helpers/helperFunctions";

const ProductSpecials = ({isHot = true, mobile}) => {

  const specialData =
    useSelector((state) => state.dynamicMultipleElements.products[isHot ? 'hotSpecial' : 'freshSpecial']);

  return (
    <div className="w-full grid product-special app-top-mg">
      <div className="w-full app-side-pd grid-area">
        <div className={`w-full bg-rand-200 ${mobile ? "aspect-focused-banner" : "aspect-ratio-special-banner_web"} app-rounded shadow-md`}
             style={{
               backgroundImage: `${!!specialData?.meta?.mobile ? `url(${safeImage(specialData?.meta?.mobile)})` : ''}`,
               backgroundSize: "cover", backgroundRepeat: "no-repeat", backgroundPosition: "center"
             }}
        />

      </div>
      <ProductListUi isCampaign={true} productData={specialData} className="pt-2 grid-area min-w-0"
                     title="" viewButtonColor="text-dark"
                     type={isHot ? PRODUCT_LIST_TYPE.hot : PRODUCT_LIST_TYPE.fresh} mobile={mobile}/>

    </div>

  );
};

export default React.memo(ProductSpecials);
